<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="scheme.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Аудиторы</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="auditors"
              [rememberSelected]="true"
              [userGroups]="userGroups"
              [users]="users"
              (selectedEntitiesChange)="onChangeUsersAndGroup('auditor')"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div class="field">
            <label class="font-medium">Доступ</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="accessUsers"
              [rememberSelected]="true"
              [userGroups]="userGroups"
              [users]="users"
              (selectedEntitiesChange)="onChangeUsersAndGroup('access')"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <p-selectButton
              [options]="typeList"
              [(ngModel)]="scheme.type"></p-selectButton>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Согласователи</label>
            <crm-multi-select
              [(selectedItems)]="scheme.users"
              [options]="users"
              appendTo="body"
              [class]="errors?.users ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.users ? 'ng-invalid ng-dirty' : ''"></crm-multi-select>
            <small
              *ngIf="errors?.users"
              class="p-error">
              {{ errors.users | join }}
            </small>

            <crm-table
              *ngIf="scheme.users?.length && scheme.type === ApprovalSchemeTypeEnum.SEQUENTIAL"
              name="approval.scheme.form"
              [columns]="columns"
              [values]="scheme.users">
              <ng-template
                #rowTemplate
                let-user="item"
                let-index="rowIndex">
                <tr [pReorderableRow]="index">
                  <td>
                    <span
                      class="pi pi-bars"
                      [pReorderableRowHandle]=""></span>
                  </td>
                  <td>{{ index + 1 }}. {{ user.name }}</td>
                </tr>
              </ng-template>
            </crm-table>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.APPROVAL_SCHEME"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="approvalSchemeService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveScheme()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete && !scheme?.['isDefault']"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteScheme()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
